import { memo, useEffect } from 'react';
import cn from 'classnames';
import { Element, RouterLink } from 'src/components';
import Level from 'src/components/grid/level';
import { Logger } from 'src/utils';
import styles from '../404/styles.module.scss';

export function Content500() {
    useEffect(() => {
        Logger.error(500, 'Error_500');
    }, []);

    return (
        <Element className={styles['error-page']}>
            <Level className={styles['error__title']}>
                <Level.Side align="left">
                    <RouterLink
                        to="/"
                        className={styles['error__logo']}
                    ></RouterLink>
                </Level.Side>
                <Level.Side align="right">
                    <RouterLink
                        to="/"
                        className={styles['error__inst']}
                        newTab={true}
                    >
                        Tải ứng dụng Báo Mới
                    </RouterLink>
                    <RouterLink
                        to="https://www.facebook.com/Baomoi"
                        className={cn(
                            styles['error__btn'],
                            styles['error__btn--fb']
                        )}
                    ></RouterLink>
                    <RouterLink
                        to="https://zalo.me/"
                        className={cn(
                            styles['error__btn'],
                            styles['error__btn--zalo']
                        )}
                    ></RouterLink>
                </Level.Side>
            </Level>
            <Element className={styles['error__content']}>
                <Element renderAs="p" className={styles['page-500']}>
                    Trang web luôn luôn được nâng cấp hàng ngày hàng giờ để phục
                    vụ yêu cầu của bạn, do vậy có thể bạn đã không may mắn truy
                    cập vào đúng lúc chúng tôi đang thực hiện công việc này.
                    <br />
                    <br />
                    Hãy thư giãn và thử lại sau một thời gian ngắn, bạn sẽ lại
                    có thể tiếp tục đọc tin.
                    <br />
                    <br />
                    Để thử lại, xin hãy bắt đầu bằng cách click vào{' '}
                    <a href="/" className={styles['link']}>
                        Trang chủ
                    </a>
                </Element>
            </Element>
        </Element>
    );
}

export default memo(Content500);
